import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

export default function HiddenText({ tradkey, values, getterName = null }) {
    const { t } = useTranslation();
    if (values.length > 0) {
        return `${t(tradkey, { count: values.length })} ${values
            .map(obj => {
                if (getterName) {
                    return obj[getterName];
                }
                return obj.name;
            })
            .join(',')}`;
    }
    return null;
}

HiddenText.propTypes = {
    tradkey: PropTypes.string.isRequired,
    getterName: PropTypes.string,
    values: PropTypes.array
};
